'use client';
export { Table, TableCaption, Tbody, Td, Tfoot, Th, Thead, Tr } from '@chakra-ui/react';
export { TableContainer } from './table-container';

//# sourceMappingURL=index.js.map